import { useSpring, animated } from "@react-spring/web";
import React, { useEffect, useState } from "react";

import selectedColorBrand from "@/config/tailwind-colors/brand-colors";
import { BrandKey } from "@/types/common-types";

function SingleItem({
  text,
  isLast,
  index,
  isAnimatingStart = false,
  onComplete,
  brand = "staysure",
}: Readonly<{
  text: string;
  isLast: boolean;
  index: number;
  isAnimatingStart?: boolean;
  brand?: BrandKey;
  onComplete: (index: number) => void;
}>) {
  const [isAnimatingFirstItem, setIsAnimatingFirstItem] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const conicColor = {
    avanti: "#387777",
    staysure: "#866595",
    expat: "#866595",
  };

  useEffect(() => {
    if (index === 1 || isAnimatingStart) {
      setIsAnimatingFirstItem(true);
    }
  }, [index, isAnimatingStart]);

  const { x } = useSpring({
    from: { x: 0 },
    to: { x: isAnimatingFirstItem ? 360 : 0 },
    config: { duration: 1500 },
    onRest: () => {
      onComplete(index);
      setIsCompleted(true);
    },
  });

  const getConic = (value: number) => {
    return `conic-gradient(${selectedColorBrand["icon-on-dark"]} 0deg, ${selectedColorBrand["icon-on-dark"]} ${value}deg, ${conicColor[brand]}  ${value}deg) border-box`;
  };

  return (
    <div
      className={`flex items-center space-x-spacing-xs text-white ${
        isLast ? "mb-[0px]" : "mb-spacing-m"
      } lg:min-h-[38px] md:min-h-fit min-h-[38px]`}
    >
      <div className="flex flex-col items-center">
        <animated.div
          style={{
            background: x.to(
              (y) => `
                linear-gradient(${selectedColorBrand["icon-on-dark"]}, ${
                  selectedColorBrand["icon-on-dark"]
                }) padding-box,
                ${getConic(y)}
              `
            ),

            width: "fit-content",
            border: "3px solid transparent",
            borderRadius: "100%",
          }}
        >
          <div
            className={`w-[18px] h-[18px] ${
              isCompleted
                ? "bg-icon-on-dark"
                : "bg-dark-surface-accent-1-primary"
            }
             text-dark-surface-accent-1-primary rounded-full font-[600] text-[17.6px] flex items-center justify-center`}
          >
            {isCompleted && index}
          </div>
        </animated.div>
        {/* 
        {!isLast && (
          <div
            className={`w-[2px] h-full min-h-[22.4px] ${isCompleted ? "bg-icon-on-dark" : "bg-[#866595]"} hidden lg:block`}
          />
        )} */}
      </div>

      <div className="min-h-[27px] flex items-center text-dark-text-body">
        <p className="my-auto font-[400] leading-[27px] text-xs">{text}</p>
      </div>
    </div>
  );
}

export default SingleItem;
